import { CustomFieldApiDto, CustomFields } from "./restModels";

export default class CustomFieldValues {
    public customFields: CustomFields[] = [];

    constructor(
        public readonly id: string,
        public readonly itemId: string,
        public readonly countItemId: string,
        public readonly assetId: number,
        customFields: CustomFields[]
    ) {
        if (customFields) {
            this.customFields = customFields;
        }
    }

    public static fromJson(json: CustomFieldApiDto): CustomFieldValues {
        const parsedCustomFields = JSON.parse(json.customFields);

        return new CustomFieldValues(
            json.id.toString(),
            json.itemId.toString(),
            json.countItemId,
            json.assetId,
            parsedCustomFields.map((field: CustomFields) => ({
                customFieldId: field.customFieldId,
                customFieldName: field.customFieldName,
                value: field.value,
            }))
        );
    }
}
